import { shift_minutes } from "src/utils/datetime";
import getStore from "@utils/redux/store";
import {
  setUserProperties,
  setPurchaseSurveyAnswers,
} from "@utils/redux/slices/userData";
import { SessionStorageKey } from "src/utils/constants";
import {
  setNoomSessionStorage,
  getNoomSessionStorage,
} from "src/utils/noomSessionStorage";

// Returns length of checkout timer in minutes
export const getTimerDuration = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const checkoutTimerFromUrl = parseInt(urlParams?.get("checkoutTimer"), 10);
  if (checkoutTimerFromUrl) {
    return checkoutTimerFromUrl;
  }
  return 15;
};

// Checks to see that the timestamp saved in the db exists and that the current date
// is past the timestamp
export const isCheckoutTimerExpired = (
  userData = getStore().getState().userData
) => {
  const timestamp = userData.checkoutTimerExpirationTimestamp;
  return timestamp && Date.now() >= timestamp;
};

// Helpers for getting and setting a value that is true if the user has been kicked
// back to landing page after the timer has expired on the checkout page
export const setCheckoutTimerExpired = (val: boolean) => {
  setNoomSessionStorage(SessionStorageKey.checkoutTimerExpired, val);
};

export const getCheckoutTimerExpired = () => {
  return getNoomSessionStorage(SessionStorageKey.checkoutTimerExpired);
};

export const trySetCheckoutTimerExpirationCookie = async () => {
  const store = getStore();
  const { userData } = store.getState();
  if (isCheckoutTimerExpired(userData)) {
    // Delete purchase survey answers in DB
    await store.dispatch(setPurchaseSurveyAnswers({}));
  }
  if (!userData.checkoutTimerExpirationTimestamp || getCheckoutTimerExpired()) {
    setCheckoutTimerExpired(false);
    await store.dispatch(
      setUserProperties({
        checkoutTimerExpirationTimestamp: shift_minutes(
          getTimerDuration()
        ).getTime(),
      })
    );
  }
};

export const clearCheckoutTimerExpirationCookie = () => {
  setCheckoutTimerExpired(false);
  return getStore().dispatch(
    setUserProperties({
      checkoutTimerExpirationTimestamp: false,
    })
  );
};

export const getElapsedDuration = () => {
  const timerDuration = getTimerDuration();
  const timestamp =
    getStore().getState().userData.checkoutTimerExpirationTimestamp;
  return timestamp
    ? Math.max(Math.ceil((timestamp - Date.now()) / (60 * 1000)), 0)
    : timerDuration;
};
